import { Organization } from '@common/entities';

import {
  FORM_KEY_TO_FREE_TEXT_KEY_MAP,
  MODEL_TO_ENTITY_FIELD_KEY_MAP,
  OrganizationModel,
} from 'src/app/organization/@shared/organization.model';
import { FormFieldKey } from 'src/app/@shared/form/form.types';

const FREE_TEXT_FIELD_TO_ORGANIZATION_FIELD_MAP = new Map<string, keyof Organization>(Object.entries(FORM_KEY_TO_FREE_TEXT_KEY_MAP)
  .map(([organizationFieldKey, freeTextFieldKey]) => {
    return [freeTextFieldKey, organizationFieldKey as keyof Organization];
  }));

export function resolveOrganizationPublicFieldKey(fieldId: FormFieldKey | string): keyof Organization {
  const modelFieldKey = fieldId as keyof OrganizationModel;
  const modelMappedFieldKey = MODEL_TO_ENTITY_FIELD_KEY_MAP[modelFieldKey];

  if (modelMappedFieldKey) {
    return modelMappedFieldKey;
  }

  const freeTextMappedFieldKey = FREE_TEXT_FIELD_TO_ORGANIZATION_FIELD_MAP.get(fieldId);

  if (freeTextMappedFieldKey) {
    return resolveOrganizationPublicFieldKey(freeTextMappedFieldKey);
  }

  if (fieldId === 'providedByRed' || fieldId === 'providedByOther') {
    return 'providedBy';
  }

  return fieldId as keyof Organization;
}

export function isOrganizationPublicField(fieldId: FormFieldKey | string, publicFieldIds: Set<keyof Organization>): boolean {
  return publicFieldIds.has(resolveOrganizationPublicFieldKey(fieldId));
}
